// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qq-9";
export var arrowButtonContainer = "_qq-5";
export var arrowButtonIcon = "_qq-6";
export var carouselArrowButton = "_qq-2";
export var carouselElementContainer = "_qq-1";
export var currentSlide = "_qq-8";
export var left = "_qq-3";
export var otherSlide = "_qq-a";
export var productCarouselContainer = "_qq-0";
export var right = "_qq-4";
export var sliderOverflow = "_qq-7";